<!--
 * @Author: zhangweinan
 * @Date: 2023-07-19 10:12:49
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-02 18:47:25
 * @Description: file content
 * @FilePath: \user-center\src\components\UploadFile\previewFile.vue
-->
<template>
  <el-link type="primary" :underline="false" @click="previewFile">{{ btnText }}</el-link>
</template>
<script setup>
import { computed } from 'vue';
import { preview } from 'vue3-preview-image';
import { downloadFile } from '../../utils/file.js';

const props = defineProps({
  url: {
    type: String,
    default: null,
  },
  btnText: {
    type: String,
    default: '查看文件',
  },
  current: {
    type: Number,
    default: 0,
  },
  prePath: {
    type: String,
    default: '/file/',
  },
});

const fileType = computed(() => {
  if (!props.url) {
    return '';
  }
  return props.url.slice(props.url.lastIndexOf('.') + 1);
});

const isImage = computed(() => {
  return ['jpg', 'JPG', 'png'].includes(fileType.value);
});

const isPDF = computed(() => {
  return fileType.value == 'pdf';
});

//预览文件
function previewFile() {
  let initPath = props.prePath || '/file/';

  console.log('props.prePath', props.url.url);
  let url = props.url.url; //initPath + props.url;
  if (isImage) {
    //图片预览
    preview(props.current, [url]); // TODO 查看多个图片
  } else if (isPDF) {
    //PDF预览
    window.open(url);
    // window.open(props.url);
  } else {
    // 其他文件类型预览
    downloadFile(url);
  }
}
</script>
